import { useState } from 'react'
import './TaskList.css'

export default function TaskList({ tasks, toggleTask, deleteTask }) {
  const [deletingTasks, setDeletingTasks] = useState(new Set())

  const handleDelete = async (id) => {
    setDeletingTasks(prev => new Set(prev).add(id))
    await deleteTask(id)
    setDeletingTasks(prev => {
      const newSet = new Set(prev)
      newSet.delete(id)
      return newSet
    })
  }

  const pendingTasks = tasks.filter(task => !task.completed)
  const completedTasks = tasks.filter(task => task.completed)

  return (
    <div className="task-list-container">
      {pendingTasks.length > 0 && (
        <div className="task-section">
          <h3 className="section-title">
            <span className="section-icon">⏳</span>
            Pending ({pendingTasks.length})
          </h3>
          <ul className="task-list">
            {pendingTasks.map((task) => (
              <TaskItem
                key={task.id}
                task={task}
                toggleTask={toggleTask}
                deleteTask={handleDelete}
                isDeleting={deletingTasks.has(task.id)}
              />
            ))}
          </ul>
        </div>
      )}

      {completedTasks.length > 0 && (
        <div className="task-section">
          <h3 className="section-title">
            <span className="section-icon">✅</span>
            Completed ({completedTasks.length})
          </h3>
          <ul className="task-list">
            {completedTasks.map((task) => (
              <TaskItem
                key={task.id}
                task={task}
                toggleTask={toggleTask}
                deleteTask={handleDelete}
                isDeleting={deletingTasks.has(task.id)}
              />
            ))}
          </ul>
        </div>
      )}
    </div>
  )
}

function TaskItem({ task, toggleTask, deleteTask, isDeleting }) {
  const [isToggling, setIsToggling] = useState(false)

  const handleToggle = async () => {
    setIsToggling(true)
    await toggleTask(task.id, task.completed)
    setIsToggling(false)
  }

  return (
    <li className={`task-item ${task.completed ? 'completed' : 'pending'} ${isDeleting ? 'deleting' : ''}`}>
      <div className="task-content" onClick={handleToggle}>
        <div className={`checkbox ${task.completed ? 'checked' : ''}`}>
          {task.completed && <span className="checkmark">✓</span>}
        </div>
        <span className={`task-text ${isToggling ? 'updating' : ''}`}>
          {task.description}
        </span>
      </div>
      <button 
        className={`delete-button ${isDeleting ? 'loading' : ''}`}
        onClick={(e) => {
          e.stopPropagation()
          deleteTask(task.id)
        }}
        disabled={isDeleting}
        title="Delete task"
      >
        {isDeleting ? (
          <div className="delete-spinner"></div>
        ) : (
          <span>🗑️</span>
        )}
      </button>
    </li>
  )
}